import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue'

export const predelavaService = {
    load,loadShema,loadOne,loadbyds,loadbymso,save,add,loadIdPoSezoni
    
};

function load(sezona) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalci/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(predelava => {
            // login successful if there's a jwt token in the response
            
            return predelava;
        }).
        catch(error=>{
            console.log(error)
        });;
}

function loadShema(sezona,shema) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalci/?sezona=${sezona}&shema=${shema}`, requestOptions)
        .then(handleResponse)
        .then(predelava => {
            // login successful if there's a jwt token in the response
            
            return predelava;
        }).
        catch(error=>{
            console.log(error)
        });;
}


function loadIdPoSezoni(sezona,subjid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/preteklasezonaid/?sezona=${sezona}&subjid=${subjid}`, requestOptions)
        .then(handleResponse)
       
}


function loadOne(sezona,predelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
       
}



function loadbyds(ds) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };
    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/ds/?ds=${ds}`, requestOptions)
        .then(handleResponse)
       
}

function loadbymso(mso) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };
    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/mso/?mso=${mso}`, requestOptions)
        .then(handleResponse)
       
}

function add(predelovalec) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(predelovalec)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dodaj`, requestOptions).then(handleResponse);
}


function save(predelovalec) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(predelovalec)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/shrani`, requestOptions).then(handleResponse);
}
